import AuthComponent from 'components/auth';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Layout from '../Layout';
import {
  FormContainer,
  ImageSignup,
  LeftSection,
  List,
  ListItem,
  RightSection,
  TextContainer,
  Title,
} from '../styles';

interface ISignupViewProps {
  lang: string;
}

const SignupView: React.FC<ISignupViewProps> = () => {
  const { t } = useTranslation();
  return (
    <Layout>
      <LeftSection>
        <ImageSignup />
        <TextContainer>
          <Title>{t('auth:AUTH_VIEW.SIGNUP_TITLE')}</Title>
          <List>
            <ListItem>{t('auth:AUTH_VIEW.SIGNUP_ITEM1')}</ListItem>
            <ListItem>{t('auth:AUTH_VIEW.SIGNUP_ITEM2')}</ListItem>
            <ListItem>{t('auth:AUTH_VIEW.SIGNUP_ITEM3')}</ListItem>
            <ListItem>{t('auth:AUTH_VIEW.SIGNUP_ITEM4')}</ListItem>
          </List>
        </TextContainer>
      </LeftSection>
      <RightSection>
        <FormContainer>
          <AuthComponent isLogin={false} />
        </FormContainer>
      </RightSection>
    </Layout>
  );
};

export default SignupView;
